enum CidRejectionCode {
  NONE = 'NONE',
  SELFSERVICE = 'SELFSERVICE',
  ALL = 'ALL',
  TAX = 'TAX',
}

export default CidRejectionCode;
